var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCloud1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 46.75L33 57.75L44 46.75",
    stroke: "#33894E",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33V57.75",
    stroke: "#33894E",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4205 49.7483C59.8113 48.0671 61.6042 45.6677 62.539 42.8984C63.4738 40.1292 63.5019 37.1341 62.6191 34.3478C61.7363 31.5615 59.9886 29.129 57.6297 27.4033C55.2707 25.6776 52.4233 24.7485 49.5005 24.7508H46.0355C45.2084 21.5274 43.6608 18.5337 41.5093 15.995C39.3578 13.4563 36.6584 11.4388 33.6143 10.0943C30.5702 8.74977 27.2608 8.11337 23.9352 8.23296C20.6096 8.35256 17.3544 9.22504 14.4148 10.7847C11.4751 12.3444 8.92761 14.5506 6.964 17.2373C5.0004 19.924 3.67188 23.0212 3.07845 26.2956C2.48503 29.57 2.64217 32.9364 3.53803 36.1413C4.4339 39.3463 6.04515 42.3062 8.25049 44.7983",
    stroke: "#ADD0B8",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCloud1);
export default __webpack_public_path__ + "static/media/download_cloud 1.3c62980dd4585b258af5b6b503def78f.svg";
export { ForwardRef as ReactComponent };